import { render, staticRenderFns } from "./bak.vue?vue&type=template&id=149844f2&scoped=true&"
import script from "./bak.vue?vue&type=script&lang=js&"
export * from "./bak.vue?vue&type=script&lang=js&"
import style0 from "./bak.vue?vue&type=style&index=0&id=149844f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149844f2",
  null
  
)

export default component.exports